// Each POC registers itself with its own file under ./entries (default export
// `{ key, name, description, reloadOnChange? }`), so several POC branches can merge onto one deploy branch
// without conflicting over a shared list. Set `reloadOnChange` when the POC only reads its
// switch at startup.
const entryModules = import.meta.glob('./entries/*.js', { eager: true });

export const POCS = Object.values(entryModules)
  .map((entryModule) => entryModule.default)
  .sort((a, b) => a.name.localeCompare(b.name));
